<template>
    <div class="u-card__intro">
        <template v-if="consultation.doctor.user.deleted_at">
            <img :src="consultation.doctor.user.avatar" class="u-card__photo avatar" alt>

            <span class="u-card__name" v-html="consultation.doctor.user.name"></span>
        </template>
        <template v-else>
            <a :href="'/doctors/' + consultation.doctor.slug">
                <img :src="consultation.doctor.user.avatar" class="u-card__photo avatar" alt>
            </a>

            <a :href="'/doctors/' + consultation.doctor.slug">
                <span class="u-card__name" v-html="consultation.doctor.user.name"></span>
            </a>
        </template>
        <span class="u-card__caption">
            <span v-for="(specialty, index) in consultation.doctor.doctor_specialties">
                {{ index ? ', ' : '' }}{{specialty.title}}
            </span>
        </span>

        <span class="u-card__caption" v-if="access === 'clinic'">
            Стоимость: <span class="u-card__meta-value">{{ consultation.payment ? consultation.payment.original_price+' ₽' : 'Бесплатно' }}</span>
        </span>
    </div>
</template>

<script>
    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';
    import api from "../../../../admin/api/api";

    dayjs.extend(utc);

    export default {
        name: "Card",
        props: {
            consultation: {
                type: Object,
                required: true
            },
            access: {
                type: String,
                required: true
            }
        },
    }
</script>
